module.exports = __webpack_public_path__ + "img/img6.651f7936.svg";